<div class="auth-wrapper" [ngClass]="{
  'processing': (authState$ | async).status === state_statuses.PROCESSING && (authState$ | async).data.auth_type === auth_types.GOOGLE,
  'disable-div': (authState$ | async).status === state_statuses.PROCESSING && (authState$ | async).data.auth_type !== auth_types.GOOGLE
}">
  <app-inline-loader bg_color="secondary"
    *ngIf="(authState$ | async).status === state_statuses.PROCESSING && (authState$ | async).data.auth_type === auth_types.GOOGLE">
  </app-inline-loader>
  <button id="asl-google-signin-button"></button>
</div>